import { priorityDownload } from 'reactApp/appHelpers/featuresHelpers/features/priorityDownload';
import type { PriorityDownloadDwhArgs } from 'reactApp/modules/priorityDownload/priorityDownload.types';
import { sendDwh } from 'reactApp/utils/ga';

const { paySource } = priorityDownload;

const sendAnalytic = ({ action, dwhData }: { action: string; dwhData: PriorityDownloadDwhArgs }) =>
    sendDwh({ eventCategory: paySource, action, dwhData });

export const PriorityDownloadAnalytics = { paySource, sendAnalytic } as const;
